/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useRef } from "react";
import { withRouter } from "react-router";

import PropTypes from "prop-types";
import { defaultCurrency } from "../../../shared/constants/currency";
import { getBackgroundImage } from "../../../shared/utilities/common";
import DiscountTagRebrand from "../../DiscountTagRebrand/DiscountTagRebrand";

import styles from "./MediumProductRebrand.module.css";

const MediumProductRebrand = props => {
  const {
    primaryImage,
    secondaryImage,
    price,
    strikePrice,
    title,
    onAdd,
    isLimited,
    onClick,
    className,
    doughProOverlay,
    calories,
    currency,
    isSingle,
    oos,
    productSlug,
    discountPercent,
    isLoading,
  } = props;
  const anchorTagRef = useRef(null);

  useEffect(() => {
    const anchor = anchorTagRef.current;
    if (!anchor) return;

    const handleClick = e => {
      e.preventDefault();
    };

    anchor.addEventListener("click", handleClick);

    // eslint-disable-next-line
    return () => {
      anchor.removeEventListener("click", handleClick);
    };
  }, []);

  const hasDiscount = discountPercent > 0;

  const getButtonIcon = () => {
    if (isSingle) {
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M2.5 8H13.5" stroke="#F1E8DE" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M8 2.5V13.5" stroke="#F1E8DE" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    }
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M6 3L11 8L6 13" stroke="#F1E8DE" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  };

  return (
    <a
      ref={anchorTagRef}
      href={`/products/${productSlug}`}
      onClick={onClick}
      onKeyDown={e => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick();
        }
      }}
      className="group"
      aria-label={`View ${title} product details`}
    >
      <div
        data-ddog-id="medium_product_rebrand"
        className={`
          ${styles.mediumWrapper}
          ${hasDiscount ? styles.mediumWrapperWithDiscount : ''}
          ${className}
          `}
      >
        {/* Title container - top, left-aligned */}
        <div
          onClick={onClick}
          className={`
            ${styles.titleContainer}
            ${hasDiscount ? styles.titleContainerWithDiscount : ''}
          `}
        >
          <h4 className={styles.title}>
            {title}
          </h4>
          {discountPercent > 0 ? (
            <div className={styles.discountTag}>
              <DiscountTagRebrand discountPercent={discountPercent} />
            </div>
          ) : null}
          {calories ? <span className={styles.calories}>{calories}</span> : null}
        </div>

        {/* Image container */}
        <div className={styles.imageContainer}>
          {secondaryImage ? (
            <img
              onClick={onClick}
              src={`${getBackgroundImage(secondaryImage)}`}
              alt=""
              aria-hidden="true"
              className={styles.secondaryImage}
            />
          ) : null}
          {isLimited ? (
            <div className={styles.limitedBadge}>
              <p className="capitalize m-0">LIMITED TIME ONLY</p>
            </div>
          ) : null}

          <img
            alt={`${title} product`}
            src={primaryImage}
            className={styles.mainImage}
          />
        </div>

        {/* Footer - price left, button right */}
        <div className={styles.footer}>
          <div className={styles.priceContainer}>
            {doughProOverlay ? (
              <h5 className={styles.memberExclusive}>CookieMagic Member Exclusive</h5>
            ) : null}
            {price ? (
              strikePrice ? (
                <span className={styles.strikePrice}>
                  <strike>{`${currency.symbol}${strikePrice}  `}</strike>
                  &nbsp;
                  {`${currency.symbol}${price}`}
                </span>
              ) : (
                <span className={styles.price}>{`${currency.symbol}${price}`}</span>
              )
            ) : null}
          </div>

          {oos === 1 && isSingle ? null : (
            isLoading ? (
              <div
                data-ddog-id="medium_product_loading"
                className={styles.ctaButtonLoading}
                aria-label="Loading"
              >
                <svg
                  className={styles.ctaSpinner}
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_10507_7736)">
                    <path
                      d="M12 24C10.3805 24 8.80781 23.6836 7.32891 23.0578C5.89922 22.4531 4.61719 21.5859 3.51563 20.4844C2.41406 19.3828 1.54688 18.1008 0.942188 16.6711C0.316406 15.1922 0 13.6195 0 12C0 11.5336 0.377344 11.1563 0.84375 11.1563C1.31016 11.1563 1.6875 11.5336 1.6875 12C1.6875 13.3922 1.95938 14.7422 2.49844 16.0148C3.01875 17.243 3.76172 18.3469 4.70859 19.2938C5.65547 20.2406 6.75938 20.9859 7.9875 21.5039C9.25781 22.0406 10.6078 22.3125 12 22.3125C13.3922 22.3125 14.7422 22.0406 16.0148 21.5016C17.243 20.9813 18.3469 20.2383 19.2938 19.2914C20.2406 18.3445 20.9859 17.2406 21.5039 16.0125C22.0406 14.7422 22.3125 13.3922 22.3125 12C22.3125 10.6078 22.0406 9.25781 21.5016 7.98516C20.983 6.75998 20.2325 5.64659 19.2914 4.70625C18.3521 3.76387 17.2385 3.01321 16.0125 2.49609C14.7422 1.95938 13.3922 1.6875 12 1.6875C11.5336 1.6875 11.1563 1.31016 11.1563 0.84375C11.1563 0.377344 11.5336 0 12 0C13.6195 0 15.1922 0.316406 16.6711 0.942188C18.1008 1.54688 19.3828 2.41406 20.4844 3.51563C21.5859 4.61719 22.4508 5.90156 23.0555 7.32891C23.6813 8.80781 23.9977 10.3805 23.9977 12C23.9977 13.6195 23.6813 15.1922 23.0555 16.6711C22.4531 18.1008 21.5859 19.3828 20.4844 20.4844C19.3828 21.5859 18.0984 22.4508 16.6711 23.0555C15.1922 23.6836 13.6195 24 12 24Z"
                      fill="#BFA1FF"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_10507_7736">
                      <rect width="23.9977" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            ) : (
              <div
                data-ddog-id="medium_product_add_one"
                role="button"
                tabIndex={0}
                aria-label={
                  isSingle ? `Add ${title} to cart` : `View ${title} details`
                }
                onClick={isSingle ? onAdd : onClick}
                onKeyDown={e => {
                  if (e.key === "Enter") {
                    if (isSingle) {
                      onAdd();
                    } else {
                      onClick();
                    }
                  }
                }}
                className={styles.ctaButton}
              >
                {getButtonIcon()}
              </div>
            )
          )}
        </div>
      </div>
    </a>
  );
};

MediumProductRebrand.propTypes = {
  primaryImage: PropTypes.node.isRequired,
  secondaryImage: PropTypes.node,
  price: PropTypes.number,
  strikePrice: PropTypes.number,
  title: PropTypes.string.isRequired,
  onAdd: PropTypes.func.isRequired,
  isLimited: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  className: PropTypes.string.isRequired,
  doughProOverlay: PropTypes.bool,
  calories: PropTypes.string,
  currency: PropTypes.shape({
    symbol: PropTypes.string,
    name: PropTypes.string,
    code: PropTypes.string
  }),
  isSingle: PropTypes.bool.isRequired,
  oos: PropTypes.number,
  productSlug: PropTypes.string,
  discountPercent: PropTypes.number,
  isLoading: PropTypes.bool
};

MediumProductRebrand.defaultProps = {
  secondaryImage: null,
  isLimited: false,
  price: null,
  strikePrice: null,
  doughProOverlay: false,
  calories: null,
  currency: defaultCurrency,
  oos: null,
  productSlug: "",
  discountPercent: 0,
  isLoading: false
};

export default withRouter(MediumProductRebrand);
